import jsPDF from 'jspdf';
import { isPublicTagHost } from './publicTagHost';

// Tag domain: Inter on screen and print windows; Calibri (Carlito embedded) in Excel and PDF.
export const TAG_FONT = isPublicTagHost();
const FILES = { normal: 'Carlito-Regular.ttf', bold: 'Carlito-Bold.ttf', italic: 'Carlito-Italic.ttf' };
const data = {};
const b64 = (buf) => { let s = ''; const b = new Uint8Array(buf); for (let i = 0; i < b.length; i += 0x8000) s += String.fromCharCode.apply(null, b.subarray(i, i + 0x8000)); return btoa(s); };
if (TAG_FONT) {
  Object.entries(FILES).forEach(([st, f]) => fetch(`/fonts/${f}`).then((r) => (r.ok ? r.arrayBuffer() : null)).then((buf) => { if (buf) data[st] = b64(buf); }).catch(() => {}));
}
const ready = () => Object.keys(data).length === 3;
jsPDF.API.events.push(['addFonts', function addCalibri() {
  if (!ready()) return;
  Object.entries(FILES).forEach(([st, f]) => { this.addFileToVFS(f, data[st]); this.addFont(f, 'calibri', st); });
}]);
// PDF font name: Calibri (Carlito embedded) on the tag domain, Helvetica otherwise / until loaded.
export const PF = () => (TAG_FONT && ready() ? 'calibri' : 'helvetica');

// Every cell of an ExcelJS workbook in Calibri.
// Calibri everywhere.
export function calibriWorkbook(wb) {
  wb.eachSheet((ws) => ws.eachRow({ includeEmpty: true }, (r) => r.eachCell({ includeEmpty: true }, (c) => { c.font = { ...(c.font || {}), name: 'Calibri' }; })));
  return wb;
}

// Print-window CSS so popup prints use Inter like the screen.
export const printFontCss = () => (TAG_FONT ? "*{font-family:'Inter',system-ui,sans-serif !important}" : '');
